import React from 'react'

const Footer = () => {
    return (
        <footer className="footer">
            <p className="footer__license">化学科研小助手 © 2018</p>
        </footer>
    )
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer.js